import React, { useEffect } from 'react';
 
function Footer(){  
    return (
         <div>
            
            <footer id="footer" className="footer">
            <div className="copyright">
                &copy; Copyright <strong><span>Magikmat</span></strong>. All Rights Reserved
            </div>
            
            </footer>
         </div>
         
    )
}

export default Footer;